import { NetworkStatus } from './network.interface';

export const isInitialized = (networkStatus: NetworkStatus) => {
  return networkStatus && networkStatus !== NetworkStatus.None;
};
